import { SupabaseService } from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";

export type MomentLogRecord = Database["public"]["Tables"]["moment_log"]["Row"];

export class SupabaseMomentLogService extends SupabaseService<"moment_log"> {
  table = "moment_log" as const;
}
